/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Outdoor_SiteInputs */

const en_val_outdoor_site = /** @type {(inputs: Val_Outdoor_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outdoor Site`)
};

const es_val_outdoor_site = /** @type {(inputs: Val_Outdoor_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitio al aire libre`)
};

const fr_val_outdoor_site = /** @type {(inputs: Val_Outdoor_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site extérieur`)
};

const de_val_outdoor_site = /** @type {(inputs: Val_Outdoor_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Außengelände`)
};

const ja_val_outdoor_site = /** @type {(inputs: Val_Outdoor_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`屋外スペース`)
};

const zh_val_outdoor_site = /** @type {(inputs: Val_Outdoor_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`户外场地`)
};

const ar_val_outdoor_site = /** @type {(inputs: Val_Outdoor_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موقع خارجي`)
};

const id_val_outdoor_site = /** @type {(inputs: Val_Outdoor_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situs Luar Ruangan`)
};

const it_val_outdoor_site = /** @type {(inputs: Val_Outdoor_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area Esterna`)
};

const ru_val_outdoor_site = /** @type {(inputs: Val_Outdoor_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открытая площадка`)
};

const pt_val_outdoor_site = /** @type {(inputs: Val_Outdoor_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local ao Ar Livre`)
};

const ko_val_outdoor_site = /** @type {(inputs: Val_Outdoor_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`야외 시설`)
};

/**
* | output |
* | --- |
* | "Outdoor Site" |
*
* @param {Val_Outdoor_SiteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_outdoor_site = /** @type {((inputs?: Val_Outdoor_SiteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Outdoor_SiteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_outdoor_site(inputs)
	if (locale === "es") return es_val_outdoor_site(inputs)
	if (locale === "fr") return fr_val_outdoor_site(inputs)
	if (locale === "de") return de_val_outdoor_site(inputs)
	if (locale === "ja") return ja_val_outdoor_site(inputs)
	if (locale === "zh") return zh_val_outdoor_site(inputs)
	if (locale === "ar") return ar_val_outdoor_site(inputs)
	if (locale === "id") return id_val_outdoor_site(inputs)
	if (locale === "it") return it_val_outdoor_site(inputs)
	if (locale === "ru") return ru_val_outdoor_site(inputs)
	if (locale === "pt") return pt_val_outdoor_site(inputs)
	return ko_val_outdoor_site(inputs)
});